export const API_GET_ALL_VALIDATION_PAUSED_REASON = 'API_GET_ALL_VALIDATION_PAUSED_REASON'
export const API_GET_ALL_VALIDATION_PAUSED_REASON_SUCCESS = 'API_GET_ALL_VALIDATION_PAUSED_REASON_SUCCESS'
export const API_GET_ALL_VALIDATION_PAUSED_REASON_FAIL = 'API_GET_ALL_VALIDATION_PAUSED_REASON_FAIL'

export const API_ADMIN_GET_ALL_VALIDATION_PAUSED_REASON = 'API_ADMIN_GET_ALL_VALIDATION_PAUSED_REASON'
export const API_ADMIN_GET_ALL_VALIDATION_PAUSED_REASON_SUCCESS = 'API_ADMIN_GET_ALL_VALIDATION_PAUSED_REASON_SUCCESS'
export const API_ADMIN_GET_ALL_VALIDATION_PAUSED_REASON_FAIL = 'API_ADMIN_GET_ALL_VALIDATION_PAUSED_REASON_FAIL'

export const API_ADMIN_GET_VALIDATION_PAUSED_REASON = 'API_ADMIN_GET_VALIDATION_PAUSED_REASON'
export const API_ADMIN_GET_VALIDATION_PAUSED_REASON_SUCCESS = 'API_ADMIN_GET_VALIDATION_PAUSED_REASON_SUCCESS'
export const API_ADMIN_GET_VALIDATION_PAUSED_REASON_FAIL = 'API_ADMIN_GET_VALIDATION_PAUSED_REASON_FAIL'

export const API_ADMIN_POST_VALIDATION_PAUSED_REASON = 'API_ADMIN_POST_VALIDATION_PAUSED_REASON';
export const API_ADMIN_POST_VALIDATION_PAUSED_REASON_SUCCESS = 'API_ADMIN_POST_VALIDATION_PAUSED_REASON_SUCCESS';
export const API_ADMIN_POST_VALIDATION_PAUSED_REASON_FAIL = 'API_ADMIN_POST_VALIDATION_PAUSED_REASON_FAIL';

export const API_ADMIN_PATCH_VALIDATION_PAUSED_REASON = 'API_ADMIN_PATCH_VALIDATION_PAUSED_REASON';
export const API_ADMIN_PATCH_VALIDATION_PAUSED_REASON_SUCCESS = 'API_ADMIN_PATCH_VALIDATION_PAUSED_REASON_SUCCESS';
export const API_ADMIN_PATCH_VALIDATION_PAUSED_REASON_FAIL = 'API_ADMIN_PATCH_VALIDATION_PAUSED_REASON_FAIL';

export const API_ADMIN_DELETE_VALIDATION_PAUSED_REASON = 'API_ADMIN_DELETE_VALIDATION_PAUSED_REASON';
export const API_ADMIN_DELETE_VALIDATION_PAUSED_REASON_SUCCESS = 'API_ADMIN_DELETE_VALIDATION_PAUSED_REASON_SUCCESS';
export const API_ADMIN_DELETE_VALIDATION_PAUSED_REASON_FAIL = 'API_ADMIN_DELETE_VALIDATION_PAUSED_REASON_FAIL';

export const ADMIN_INIT_NEW_VALIDATION_PAUSED_REASON = 'ADMIN_INIT_NEW_VALIDATION_PAUSED_REASON'

export const ADMIN_RESET_FOCUS_VALIDATION_PAUSED_REASON = 'ADMIN_RESET_FOCUS_VALIDATION_PAUSED_REASON'